import { Icon } from '@/assets/icons'
import { LicenseBookingConditionsLabelStyle } from '@/store/licenseSlice'

interface Props {
  bookingConditionsLabelStyle: LicenseBookingConditionsLabelStyle | null
  isBookingRefundable: boolean
}
export const RefundPolicyIcon = (props: Props) => {
  if (!props.bookingConditionsLabelStyle) {
    return props.isBookingRefundable ? (
      <Icon className="size-5 shrink-0 text-green-500" name="Approve" />
    ) : (
      <Icon
        className="size-5 shrink-0 text-red-500"
        name="TriangleExclamationMark"
      />
    )
  }

  switch (props.bookingConditionsLabelStyle) {
    case LicenseBookingConditionsLabelStyle.INFO:
      return <Icon className="size-5 shrink-0 text-green-500" name="Approve" />
    case LicenseBookingConditionsLabelStyle.WARNING:
      return (
        <Icon
          className="size-5 shrink-0 text-yellow-500"
          name="TriangleExclamationMark"
        />
      )
    case LicenseBookingConditionsLabelStyle.DANGER:
      return (
        <Icon
          className="size-5 shrink-0 text-green-500"
          name="TriangleExclamationMark"
        />
      )
  }
}
